<template>
  <v-bottom-navigation
      v-if="this.$vuetify.display.mobile"
      class="bg-primary"
  >
    <v-btn min-width="50" :ripple="false" to="/">
      <v-icon size="x-large">mdi-home</v-icon>
      홈
    </v-btn>
    <v-btn min-width="50" class="no-box-shadow" variant="plain" :ripple="false" @click="goToRoomPage">
      <v-icon size="x-large">mdi-sofa-single-outline</v-icon>
      객실
    </v-btn>
    <v-btn min-width="50" :ripple="false" to="/upjang">
      <v-icon size="x-large">mdi-cart-variant</v-icon>
      주문/구매
    </v-btn>
    <v-btn min-width="50" :ripple="false" to="/ticket">
      <v-icon size="x-large">mdi-ticket-percent-outline</v-icon>
      티켓
    </v-btn>
    <v-btn min-width="50" class="no-box-shadow" variant="plain" :ripple="false" @click="goToMobileWebPage">
      <v-icon size="x-large">mdi-web</v-icon>
      홈페이지
    </v-btn>
  </v-bottom-navigation>


  <form ref="sitePassForm" action="" method="POST">
    <input type="hidden" name="corp" :value="corpCode">
    <input type="hidden" name="passHpNo" :value="phoneNumber">
  </form>
</template>

<script>
import commonStore from "@/store/common";
import authStore from "@/store/auth";
import cartStore from "@/store/cart";

export default {
  name: "MobileFooter",
  data() {
    return {
      corpCode: '',
      phoneNumber: '',
    }
  },
  created() {
    this.corpCode = commonStore.state.common.corpCode
    this.phoneNumber = authStore.state.authInfo.phoneNumber
  },
  methods: {
    goToMobileWebPage() {
      window.location.href = "https://www.yongpyong.co.kr/mobile/kor/index.do"
    },
    goToRoomPage() {
      const myForm = this.$refs.sitePassForm;
      myForm.action = process.env.VUE_APP_ROOM_SERVER_URL;
      myForm.submit();
      //window.location.href = process.env.VUE_APP_ROOM_SERVER_URL + "?corp=" + commonStore.state.common.corpCode + "&passHpNo=" + authStore.state.authInfo.phoneNumber
    }
  }
}
</script>

<style scoped>
.no-box-shadow {
  opacity: 100 !important;
  box-shadow: none !important;
}
</style>